import { Action } from '@ngrx/store';
import { type } from './action.util';

export const ActionTypes = {
  PRELOAD_DATA_ITEM:                type('[Object] Preload Data Item'),
  LOAD_DATA_ITEM:                   type('[Object] Load Data Item'),
  GET_DATA_SLICE:                   type('[Object] Get Data Slice'),
  UPDATE_DATA_SLICE:                type('[Object] Update Data Slice'),
  GET_DATA_SLICE_SUCCESS:           type('[Object] Get Data Slice Success'),
  LOAD_DATA_ITEM_SUCCESS:           type('[Object] Load Data Item Success'),
  LOAD_DATA_ITEM_FAIL:              type('[Object] Load Data Item Fail'),
  LOAD_EXISTING_DATA_ITEM:          type('[Object] Load Existing Data Item'),
  LOAD_EXISTING:                    type('[Object] Load Existing Complete Item'),
  SELECT_DATA_ITEM_BY_KEY:          type('[Object] Select Data Item By Key'),
  NAVIGATE:                         type('[Object] Navigate To Route'),
  EMPTY_STATE_KEYS:                 type('[Object] Empty State Keys'),
  SET_INTERNAL_STATE_VALUE:         type('[Object] Set Internal State Value'),
  REPLACE_INTERNAL_STATE:           type('[Object] Replace Internal State'),
  EMPTY_DATA_KEYS:                  type('[Object] Empty Data Keys'),
  REMOVE_SEARCH_DATA:               type('[Object] Remove Search Data'),
  REMOVE_SERIES_KEY:                type('[Object] Remove Series Key'),
  REMOVE_DATA_ENTITY_LIST:          type('[Object] Remove Data Entity List')
};

export class RemoveSearchData implements Action {
  type = ActionTypes.REMOVE_SEARCH_DATA;
  constructor(public payload: any) { }
}

export class RemoveSeriesKey implements Action {
  type = ActionTypes.REMOVE_SERIES_KEY;
  constructor(public payload: any) { }
}

export class RemoveDataEntityList implements Action {
  type = ActionTypes.REMOVE_DATA_ENTITY_LIST;
  constructor(public payload: any) { }
}

export class Navigate implements Action {
  type = ActionTypes.NAVIGATE;
  constructor(public payload: any) { }
}

export class UpdateDataSlice implements Action {
  type = ActionTypes.UPDATE_DATA_SLICE;
  constructor(public payload: Object) { }
}

export class GetDataSlice implements Action {
  type = ActionTypes.GET_DATA_SLICE;
  constructor(public payload: Object) { }
}

export class GetDataSliceSuccess implements Action {
  type = ActionTypes.GET_DATA_SLICE_SUCCESS;
  constructor(public payload: Object) { }
}

export class PreloadDataItemAction implements Action {
  type = ActionTypes.PRELOAD_DATA_ITEM;
  constructor(public payload: string) { }
}

export class LoadDataItemAction implements Action {
  type = ActionTypes.LOAD_DATA_ITEM;
  constructor(public payload: Object) { }
}
//success reduce the data in the store
export class LoadDataItemSuccessAction implements Action {
  type = ActionTypes.LOAD_DATA_ITEM_SUCCESS;

  constructor(public payload: Object) { }
}
//error handling if either the "read" or the "validation" fail
export class LoadDataItemFailAction implements Action {
  type = ActionTypes.LOAD_DATA_ITEM_FAIL;

  constructor(public payload: any) { }
}

export class LoadExistingDataItemAction implements Action {
  type = ActionTypes.LOAD_EXISTING_DATA_ITEM;

  constructor(public payload: any) { }
}

export class LoadExistingAction implements Action {
  type = ActionTypes.LOAD_EXISTING;

  constructor(public payload: any) { }
}

export class EmptyStateKeys implements Action {
  type = ActionTypes.EMPTY_STATE_KEYS;

  constructor(public payload: any) { }
}

//this action just returns the data state, which is helpful to init data 
//with default state
export class SelectDataItemByKeyAction implements Action {
  type = ActionTypes.SELECT_DATA_ITEM_BY_KEY;

  constructor(public payload: string) { }
}

export class SetInternalStateValue implements Action {
  type = ActionTypes.SET_INTERNAL_STATE_VALUE;
  constructor(public payload: any) { }
}

export class ReplaceInternalState implements Action {
  type = ActionTypes.REPLACE_INTERNAL_STATE;
  constructor(public payload: any) { }
}

export class EmptyDataEntities implements Action {
  type = ActionTypes.EMPTY_DATA_KEYS;
  constructor(public payload: any) { }
}


export type Actions
  = LoadDataItemSuccessAction
  | PreloadDataItemAction
  | LoadDataItemAction
  | LoadDataItemFailAction
  | SelectDataItemByKeyAction
  | LoadExistingDataItemAction
  | UpdateDataSlice
  | GetDataSlice
  | GetDataSliceSuccess
  | LoadExistingAction
  | Navigate
  | EmptyStateKeys
  | SetInternalStateValue
  | ReplaceInternalState
  | EmptyDataEntities
  | RemoveSearchData
  | RemoveSeriesKey
  | RemoveDataEntityList
 


// WEBPACK FOOTER //
// ./src/angular-engine/engine/state/action/core.actions.ts